<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="group.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Роли</label>
            <crm-multi-select
              [options]="roles"
              [(selectedItems)]="group.roles"
              [class]="errors?.roles ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-multi-select>
            <small
              *ngIf="errors?.roles"
              class="p-error">
              {{ errors.roles | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Компании</label>
            <crm-multi-select
              [options]="companies"
              [(selectedItems)]="group.companies"
              [class]="errors?.companies ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-multi-select>
            <small
              *ngIf="errors?.companies"
              class="p-error">
              {{ errors.companies | join }}
            </small>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveGroup()"></button>
      <button
        *ngIf="(form$ | async)?.isShowDelete"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteGroup()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
